<template>
  <div>
    <Modal
      :loading="loading"
      v-model="showModel"
      :width="1000"
      :title="!disabled? '新增':'详情'"
      @on-ok="save"
      :footer-hide="disabled"
      @on-cancel="closeModel">
      <!--    <div class="button-area">-->
      <!--      <Button @click="save()" :loading="saveLoading" type="primary" class="button-right-left">保存</Button>-->
      <!--      <Button @click="back()" class="button-right">返回</Button>-->
      <!--    </div>-->
      <div class="form-area">
        <Form :disabled="disabled" style="width: 800px"
              :model="model"
              :label-width="110"
              label-position="left"
              :rules='rules'
              ref="form"
              inline>
          <FormItem :class="{'model-hidden': true}" label="文本框">
            <Input v-model="model.id" type="text"></Input>
          </FormItem>
          <FormItem :class="{'model-hidden': true}" label="文本框">
            <Input v-model="model.delFlag" type="text"></Input>
          </FormItem>
          <FormItem :class="{'model-hidden': true}" label="文本框">
            <Input v-model="model.createBy" type="text"></Input>
          </FormItem>
          <FormItem :class="{'model-hidden': true}" label="文本框">
            <Input v-model="model.createTime" type="text"></Input>
          </FormItem>
          <FormItem :class="{'model-hidden': true}" label="文本框">
            <Input v-model="model.updateBy" type="text"></Input>
          </FormItem>
          <FormItem :class="{'model-hidden': true}" label="文本框">
            <Input v-model="model.updateTime" type="text"></Input>
          </FormItem>
          <Row>
            <FormItem label="标题" prop="title">
              <Input v-model="model.title" style="width:320px" type="text"></Input>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="链接" prop="link">
              <Input v-model="model.link" style="width:320px" type="text"></Input>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="上传音频" prop="audioName">
              <uploadFile  :type-arr="['mp3']" useOOS :limit="1" v-model="model.audioName" v-if="!disabled"></uploadFile>
            </FormItem>
          </Row>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
import util from '@/libs/util.js'
import uploadFile from "@/views/components/uploadFile";

export default {
  name: 'tqtPolicyConfig1Form',
  components: {uploadFile},
  data() {
    return {
      uploadUrl: util.baseUrl + "api/common/upload",
      //ID
      id: null,
      saveLoading: false,
      unitList: [],
      tagOption: [],
      content: null,
      loading: true,
      showModel: false,
      //表单参数
      model: {
        id: null,
        title: null,
        link: null,
        audioName: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,

      },
      rules: {
        title: [{required: true, message: '标题', trigger: 'blur'}],
        link: [{required: true, message: '链接', trigger: 'blur'}],
        audioName: [{required: true, message: '上传音频', trigger: 'change'}],
      },
      tagList: [],
      disabled: false,
      fileList: []
    };
  },
  mounted() {
    // this.unitList = this.$route.params.unitList
    // if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
    //   this.id = this.$route.query.id;
    //   //ID存在渲染表单
    //   this.initForm();
    // }
    // this.disabled = this.$route.query.disabled;


  },
  methods: {
    addTag() {
      // this.model.policyTag;
    },
    openModel(id) {
      if (id) {
        this.id = id
        this.initForm()
      }
      // 重置实体类

      this.$refs.form.resetFields()
      this.showModel = true
    },
    closeModel() {
      this.model = {
        id: null,
        title: null,
        link: null,
        audioName: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
      }
      this.fileList = []
      this.$refs.form.resetFields()
      this.loading = true
      this.showModel = false
      this.id = ''

      // this.s
    },


    //保存
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.id) {
            this.update();
          } else {
            this.create();
          }
        } else {
          this.loading = false
        }
      })
    },


    create() {
      console.log('create',this.model)
      let _this = this;
      _this.saveLoading = true;
      let params = {
        title:this.model.title,
        link:this.model.link,
        audioName:this.model.audioName.split(',')[1],
        audioLink:this.model.audioName.split(',')[0],
      }
      console.log(params)
      util.ajax
        .post("/api/policyConfig/new/save", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(function (response) {
          _this.$Notice.success({
            title: '保存成功!'
          });
          _this.$emit('ok')

          _this.closeModel()
          // _this.back()
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: '保存失败!'
          });
          _this.saveLoading = false;
          _this.loding = false;
          console.log(error);
        });
    },

    update() {
      let _this = this;
      _this.saveLoading = true;
      util.ajax
        .put("/api/policyConfig/tqtPolicyConfigs", this.model, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(function (response) {
          _this.$Notice.success({
            title: '更新成功!'
          });
          // _this.back()
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: '更新失败!'
          });
          _this.saveLoading = false;
          console.log(error);
        });
    },


    //渲染表单
    initForm() {
      let _this = this;
      util.ajax
        .get("/api/policyConfig/tqtPolicyConfig/" + this.id, {
          params: {}
        })
        .then(function (response) {
          let tem = response.data;
          _this.model.id = tem.id
          _this.model.policyName = tem.policyName
          _this.model.policyLevel = tem.policyLevel
          _this.model.policyTag = tem.policyTag.split(',')
          // [{value: query, label: query}]
          _this.tagOption = tem.policyTag.split(',').map(item => ({value: item, label: item}))
          _this.model.declareStartTime = tem.declareStartTime
          _this.model.declareEndTime = tem.declareEndTime
          _this.model.supportAmount = tem.supportAmount
          _this.model.releaseUnit = tem.releaseUnit
          _this.model.policyDetail = tem.originalPolicyDetail
          _this.model.delFlag = tem.delFlag
          _this.model.createBy = tem.createBy
          _this.model.createTime = tem.createTime
          _this.model.updateBy = tem.updateBy
          _this.model.updateTime = tem.updateTime
          _this.model.declareTime = [tem.declareStartTime, tem.declareEndTime]
          // _this.editor.txt.html(tem.policyDetail)
          // TODO 禁用富文本
          _this.fileList = tem.imgList
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: '获取表单失败!'
          });
          console.log(error);
        });
    },

    //返回,需要自定义配置路由
    back() {
      let _this = this;
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'tqt_policy'
      })
      _this.$router.back();
    }
  }
};
</script>

<style scoped>
.button-area {
  display: flex;
  justify-content: flex-end;
}

.button-right-left {
  margin-right: 15px;
}

.button-right {
  margin-right: 55px;
}

.form-area {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.form-flex {
  display: flex;
  justify-content: space-between;
}

.model-hidden {
  display: none;
}

.ivu-modal {
  width: 1000px;
}

</style>
